import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Banertomumbaicabs() {



  const cardData = {


     keyword: "Baner to Mumbai Cabs",

  headingDescription: "Trustline Cab offers dependable Baner to Mumbai cab services with comfortable, affordable, and chauffeur-driven taxis for business travel, airport transfers, corporate meetings, family vacations, and outstation trips. Whether you need a one-way cab or a round-trip taxi, our experienced drivers ensure safe, punctual, and hassle-free travel. Choose from our fleet of AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and premium vehicles with transparent pricing, doorstep pickup, and 24/7 customer support. Trustline Travels is your trusted choice for reliable Baner to Mumbai taxi services, delivering a smooth journey with professional service and no hidden charges.",

  topPlaces: [
    {
      title: "Nariman Point",
      description: "Nariman Point is Mumbai's prestigious financial district, home to leading corporate headquarters, banks, business centers, and premium commercial offices."
    },
    {
      title: "Lower Parel",
      description: "Lower Parel is a thriving commercial hub featuring multinational companies, modern office towers, luxury hotels, and premium shopping destinations."
    },
    {
      title: "SEEPZ MIDC",
      description: "SEEPZ MIDC is one of India's largest export processing zones, housing renowned IT companies, software firms, and manufacturing businesses."
    },
    {
      title: "Powai Business District",
      description: "Powai is a major IT and business destination with corporate offices, Hiranandani Business Park, startups, and educational institutions."
    },
    {
      title: "NESCO Business Centre",
      description: "NESCO Business Centre hosts major exhibitions, trade fairs, corporate conferences, and business events throughout the year."
    },
    {
      title: "Vashi Commercial Hub",
      description: "Vashi is an important commercial center in Navi Mumbai known for corporate offices, shopping complexes, educational institutes, and excellent connectivity."
    },
    {
      title: "Global Vipassana Pagoda",
      description: "Global Vipassana Pagoda is an architectural landmark offering a peaceful meditation center and panoramic views of the Arabian Sea."
    },
    {
      title: "Aksa Beach",
      description: "Aksa Beach is a serene coastal destination known for its clean shoreline, peaceful surroundings, and relaxing atmosphere away from city crowds."
    },
    {
      title: "Worli Sea Face",
      description: "Worli Sea Face is a popular waterfront promenade offering spectacular sea views, refreshing breezes, and a glimpse of the iconic Sea Link."
    },
    {
      title: "Jehangir Art Gallery",
      description: "Jehangir Art Gallery is one of Mumbai's most celebrated cultural attractions, showcasing contemporary and traditional artworks by renowned artists."
    }
  ],





"services": [
  {
    "name": "Baner to Mumbai Taxi Fare",
    "description": "Check Baner to Mumbai taxi fare with transparent pricing for Sedan, Ertiga, Innova Crysta, SUVs, and premium vehicles. Fixed fares, professional chauffeurs, and no hidden charges make your one-way, round-trip, airport, and corporate travel affordable and convenient."
  },
  {
    "name": "Baner to Mumbai One Way Cab",
    "description": "Book Baner to Mumbai one way cab and pay only for your single journey. Enjoy comfortable AC vehicles, doorstep pickup, experienced drivers, and affordable pricing for airport transfers, business trips, and family travel."
  },
  {
    "name": "Baner to Mumbai Taxi Service",
    "description": "Reliable Baner to Mumbai taxi service for one-way, airport transfer, business travel, sightseeing, and round-trip journeys. Choose from Sedan, Ertiga, Innova Crysta, SUVs, and luxury vehicles with professional chauffeurs."
  },
  {
    "name": "Baner to Mumbai Airport Drop",
    "description": "Book Baner to Mumbai Airport drop service with punctual pickup, luggage assistance, and direct transportation to domestic and international terminals. Ideal for stress-free airport transfers."
  },
  {
    "name": "Baner to Mumbai Airport Cab Service",
    "description": "Baner to Mumbai Airport cab service offers reliable airport transfers with flight tracking, experienced chauffeurs, comfortable AC vehicles, and timely arrival for every flight."
  },
  {
    "name": "Baner to Mumbai Ertiga Cab Service",
    "description": "Choose Baner to Mumbai Ertiga cab service for spacious family travel, airport transfers, and group journeys. Enjoy comfortable seating, ample luggage space, and affordable pricing."
  },
  {
    "name": "Baner to Mumbai International Airport Cab",
    "description": "Book Baner to Mumbai International Airport cab for direct transfers to Chhatrapati Shivaji Maharaj International Airport with professional drivers, luggage support, and comfortable travel."
  },
  {
    "name": "Baner to Mumbai Innova Crysta Cab",
    "description": "Premium Baner to Mumbai Innova Crysta cab offers luxury seating, spacious interiors, extra luggage capacity, and smooth highway travel for business executives, families, and airport passengers."
  },
  {
    "name": "Baner to Mumbai Sedan Cab",
    "description": "Affordable Baner to Mumbai sedan cab service for individuals, couples, and small families. Clean AC vehicles, fixed fares, and professional chauffeurs ensure a comfortable journey."
  },
  {
    "name": "Baner to Mumbai Swift Dzire Car",
    "description": "Book Baner to Mumbai Swift Dzire car for economical one-way, airport, and business travel with comfortable seating, excellent mileage, and dependable chauffeur service."
  },
  {
    "name": "Baner to Mumbai Round Trip",
    "description": "Baner to Mumbai round trip cab service provides flexible return schedules for business meetings, sightseeing, family travel, and corporate visits with affordable package pricing."
  },
  {
    "name": "Pune to Mumbai Ertiga Cab",
    "description": "Reliable Pune to Mumbai Ertiga cab service with spacious seating, comfortable interiors, and experienced drivers for airport transfers, family travel, and corporate transportation."
  },
  {
    "name": "Pune to Mumbai Innova Cab",
    "description": "Premium Pune to Mumbai Innova cab offers luxury travel with spacious seating, smooth highway performance, professional chauffeurs, and ample luggage space."
  },
  {
    "name": "Baner to Mumbai Airport Cabs",
    "description": "Book Baner to Mumbai Airport cabs for timely airport transfers with flight monitoring, fixed pricing, and comfortable vehicles available 24x7."
  },
  {
    "name": "Baner to Airport Cabs Booking Online",
    "description": "Reserve Baner to airport cabs online with instant confirmation, secure booking, transparent pricing, and multiple vehicle options for domestic and international airport transfers."
  },
  {
    "name": "Baner to Andheri Cab Booking",
    "description": "Book Baner to Andheri cab for business meetings, airport travel, corporate visits, and personal transportation with reliable drivers and comfortable vehicles."
  },
  {
    "name": "Baner to Borivali Cab Booking",
    "description": "Reliable Baner to Borivali cab booking service offering direct transportation with affordable fares, clean vehicles, and professional chauffeurs."
  },
  {
    "name": "Baner to Mumbai Central Cab",
    "description": "Book Baner to Mumbai Central cab for railway station transfers, business travel, and city transportation with punctual pickups and comfortable AC vehicles."
  },
  {
    "name": "Baner to Bandra Cab",
    "description": "Baner to Bandra cab service provides safe and comfortable travel for business meetings, hotels, offices, and airport connectivity with experienced chauffeurs."
  },
  {
    "name": "Baner to Dadar Cabs",
    "description": "Reserve Baner to Dadar cab for railway station transfers, business travel, and family visits with reliable chauffeur service and affordable pricing."
  },
  {
    "name": "Velocity Cabs",
    "description": "Velocity Cabs provides reliable intercity, airport, local, and outstation taxi services with Sedan, Ertiga, Innova Crysta, SUVs, luxury vehicles, transparent pricing, and professional drivers."
  },
  {
    "name": "Cab Service in Pune",
    "description": "Our cab service in Pune offers local taxi, airport transfer, corporate travel, and outstation cab services with experienced chauffeurs and a wide range of comfortable vehicles."
  },
  {
    "name": "Pune to Mumbai Airport Cab",
    "description": "Book Pune to Mumbai Airport cab with direct transfers to all airport terminals, flight tracking, luggage assistance, and timely pickup for domestic and international flights."
  },
  {
    "name": "Pune Mumbai Cab",
    "description": "Reliable Pune Mumbai cab service for one-way, airport, business, sightseeing, and round-trip travel with fixed fares and professional chauffeur service."
  },
  {
    "name": "Baner to Mumbai Cab",
    "description": "Book Baner to Mumbai cab for safe, affordable, and comfortable intercity travel with Sedan, Ertiga, Innova Crysta, SUVs, and premium vehicles available 24x7."
  },
  {
    "name": "Baner to Mumbai Taxi",
    "description": "Professional Baner to Mumbai taxi service with fixed pricing, experienced chauffeurs, comfortable AC vehicles, and reliable transportation for every travel requirement."
  },
  {
    "name": "Baner to Mumbai Cab Service",
    "description": "Choose Baner to Mumbai cab service for airport transfers, corporate travel, one-way trips, sightseeing, and round-trip packages with transparent pricing."
  },
  {
    "name": "Baner to Mumbai Cab Booking",
    "description": "Book Baner to Mumbai cab online with instant confirmation, flexible pickup timing, multiple vehicle categories, and dependable customer support."
  },
  {
    "name": "Cab from Baner to Mumbai",
    "description": "Reserve a cab from Baner to Mumbai with professional chauffeurs, comfortable AC vehicles, fixed pricing, and convenient doorstep pickup."
  },
  {
    "name": "Baner to Mumbai Car Rental",
    "description": "Baner to Mumbai car rental service offers one-way, airport transfer, business travel, sightseeing, and round-trip packages with premium chauffeur-driven vehicles."
  },
  {
    "name": "Cheap Baner to Mumbai Cab",
    "description": "Book cheap Baner to Mumbai cab for economical travel without compromising comfort, safety, or punctuality. Affordable packages are available for every traveler."
  },
  {
    "name": "Book Baner to Mumbai Cab Online",
    "description": "Book Baner to Mumbai cab online with secure reservations, instant confirmation, transparent pricing, and professional chauffeur service available throughout the day."
  },
  {
    "name": "Baner to Mumbai Outstation Cab",
    "description": "Reliable Baner to Mumbai outstation cab service offering long-distance travel with experienced drivers, comfortable vehicles, and flexible travel schedules."
  },
  {
    "name": "Baner to Mumbai Airport Cab",
    "description": "Book Baner to Mumbai Airport cab for direct airport transportation with flight tracking, luggage support, and timely arrival at domestic or international terminals."
  },
  {
    "name": "24x7 Baner to Mumbai Taxi Service",
    "description": "Our 24x7 Baner to Mumbai taxi service is available day and night for airport transfers, business travel, emergencies, and family trips with instant booking."
  },
  {
    "name": "Best Baner to Mumbai Cab Service",
    "description": "Experience the best Baner to Mumbai cab service with premium vehicles, professional chauffeurs, transparent pricing, instant booking, and outstanding customer support."
  }
],

"tableData": [
  ["Baner to Mumbai Taxi Fare", "Baner to Mumbai One Way Cab"],
  ["Baner to Mumbai Taxi Service", "Baner to Mumbai Airport Drop"],
  ["Baner to Mumbai Airport Cab Service", "Baner to Mumbai Ertiga Cab Service"],
  ["Baner to Mumbai International Airport Cab", "Baner to Mumbai Innova Crysta Cab"],
  ["Baner to Mumbai Sedan Cab", "Baner to Mumbai Swift Dzire Car"],
  ["Baner to Mumbai Round Trip", "Pune to Mumbai Ertiga Cab"],
  ["Pune to Mumbai Innova Cab", "Baner to Mumbai Airport Cabs"],
  ["Baner to Airport Cabs Booking Online", "Baner to Andheri Cab Booking"],
  ["Baner to Borivali Cab Booking", "Baner to Mumbai Central Cab"],
  ["Baner to Bandra Cab", "Baner to Dadar Cabs"],
  ["Velocity Cabs", "Cab Service in Pune"],
  ["Pune to Mumbai Airport Cab", "Pune Mumbai Cab"],
  ["Baner to Mumbai Cab", "Baner to Mumbai Taxi"],
  ["Baner to Mumbai Cab Service", "Baner to Mumbai Cab Booking"],
  ["Cab from Baner to Mumbai", "Baner to Mumbai Car Rental"],
  ["Cheap Baner to Mumbai Cab", "Book Baner to Mumbai Cab Online"],
  ["Baner to Mumbai Outstation Cab", "Baner to Mumbai Airport Cab"],
  ["24x7 Baner to Mumbai Taxi Service", "Best Baner to Mumbai Cab Service"]
],






whychoose: [
  {
    WhyChooseheading: "Trusted Baner to Mumbai Cab Service",
    WhyChoosedescription: "Trustline Cab provides reliable Baner to Mumbai cab services with comfortable vehicles for business, airport, and personal travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Baner",
    WhyChoosedescription: "Enjoy hassle-free pickup from Baner, Balewadi, Aundh, Pashan, Sus, and nearby locations at your preferred time."
  },
  {
    WhyChooseheading: "Safe & Experienced Drivers",
    WhyChoosedescription: "Our professional chauffeurs are experienced on the Mumbai-Pune Expressway, ensuring a smooth and secure journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Book your Baner to Mumbai cab with upfront pricing, fair fares, and absolutely no hidden charges."
  },
  {
    WhyChooseheading: "Clean & Comfortable Vehicles",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, and maintained to provide a pleasant travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Availability",
    WhyChoosedescription: "Choose from one-way cabs, round trips, or customized travel packages based on your schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Select from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your travel requirements."
  },
  {
    WhyChooseheading: "Fast Booking Confirmation",
    WhyChoosedescription: "Our dedicated support team provides instant quotations and quick booking confirmation for every trip."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Baner to Mumbai cab service?",
    answer: "Yes, Trustline Cab offers dependable cab services from Baner to Mumbai for one-way, round-trip, airport, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Baner to Mumbai?",
    answer: "Yes, we provide affordable one-way cab services with flexible pickup timings from Baner and nearby areas."
  },
  {
    question: "Which vehicles are available for Baner to Mumbai travel?",
    answer: "We offer Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers to suit different passenger requirements."
  },
  {
    question: "Do you provide pickup from nearby areas of Baner?",
    answer: "Yes, we provide pickup from Baner, Balewadi, Aundh, Pashan, Sus, Mahalunge, and surrounding locations."
  },
  {
    question: "Can I book a cab for Mumbai Airport?",
    answer: "Yes, we provide direct cab services to Mumbai Airport Terminal 1 and Terminal 2 from Baner."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specified in the booking quotation."
  },
  {
    question: "Is your Baner to Mumbai cab service available 24/7?",
    answer: "Yes, Trustline Travels operates round the clock for customer convenience, including early morning and late-night travel."
  },
  {
    question: "Can I pre-book my cab?",
    answer: "Yes, advance booking is recommended to secure your preferred vehicle and pickup schedule."
  },
  {
    question: "Do you provide cabs for business travel from Baner?",
    answer: "Yes, we regularly serve corporate professionals traveling from Baner to Mumbai for meetings, conferences, and office visits."
  },
  {
    question: "How can I book a Baner to Mumbai cab with Trustline Travels?",
    answer: "Simply share your pickup location, destination, travel date, and preferred vehicle to receive an instant fare quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Bhosale",
    feedback: "I booked a cab from Baner to Mumbai for an important client meeting. Trustline Travels provided a punctual driver, a clean vehicle, and a comfortable journey throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Chavan",
    feedback: "Our family needed an early morning pickup from Baner for Mumbai Airport. Trustline Travels handled everything professionally, and the ride was smooth, safe, and completely stress-free.",
    rating: 5
  }
];













  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Baner to Mumbai Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/baner-to-mumbai-cab.webp",
  "description": "Book Baner to Mumbai cab service for safe, comfortable, and affordable intercity travel. Trustline Travels offers one-way, round-trip, and Mumbai Airport taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/baner-to-mumbai-cab"
  }
};









  return (
    <div>
<Helmet>
  <title>Baner to Mumbai Cab | One Way & Airport Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Baner to Mumbai cab service at affordable fares with Trustline Travels. Choose Sedan, Ertiga, SUV, Innova, or Innova Crysta taxis for one-way, round-trip, and Mumbai Airport transfers with 24x7 professional taxi service."
  />

  <meta
    name="keywords"
    content="baner to mumbai taxi fare, baner to mumbai one way cab, baner to mumbai taxi service, baner to mumbai airport drop, baner to mumbai airport cab service, baner to mumbai ertiga cab service, baner to mumbai international airport cab, baner to mumbai, baner to mumbai cab, baner to mumbai taxi, baner to mumbai airport taxi, baner to mumbai innova cab, baner to mumbai sedan cab, affordable baner to mumbai cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/37.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Banertomumbaicabs;